

(function(global){

  /**
   * This function is added to check the type of user.
   * @param user, role
   * */

  var userHasRole = function (user, role) {
    if (!user || !user.roles.Map) {
      return false;
    } else {
      return user.roles.Map[role] && user.roles.Map[role].Valid;
    }
  };

  module.exports = {
    userHasRole: userHasRole
  };

})(this);